/**
 * Підписи полів справи (`SPEC-011` §8.8): дослівно з легасі, крім «Тип
 * активності» → «Тип справи» (`SPEC-002` §2.5). Спільні для ресурсу, шапки,
 * вкладки власника й календаря.
 */
export const ACTIVITY_FIELD_LABELS = {
    id: 'Ід',
    type: 'Тип справи',
    client: 'Клієнт',
    clientContact: 'Контакт клієнта',
    carrier: 'Перевізник',
    carrierContact: 'Контакт перевізника',
    owner: 'Клієнт|Перевізник',
    status: 'Статус',
    deadline: 'Крайній термін',
    responsible: 'Відповідальний',
    description: 'Опис',
    result: 'Результат',
    doneBy: 'Ким завершено',
    doneAt: 'Дата та час завершення',
    createdAt: 'Дата та час створення',
    createdBy: 'Ким створено',
    updatedAt: 'Дата та час зміни',
    updatedBy: 'Ким змінено',
} as const

/** Межа опису й результату — та сама, що на беку (`SPEC-011` І6). */
export const ACTIVITY_TEXT_MAX_LENGTH = 4096

/** Позначка простроченої справи — словом поруч із кольором (`SPEC-014` §1.5). */
export const ACTIVITY_OVERDUE_LABEL = 'Прострочена'
